global.JsBarcode = require('jsbarcode');